export const toNumericIds = (ids: string[] = []) =>
    ids.map(id => parseInt(id)).filter(id => !isNaN(id));

export const buildEsiInclude = (
    partialPath: string,
    params: Record<string, string | number | boolean>,
) => {
    const queryString = Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
    return `<esi:include src="${process.env.NEXT_PUBLIC_SSR_API_HOST}/partials/${partialPath}?${queryString}" onerror=continue />`;
};
